import React, {Component} from "react";
import google_adwords_logo from '../../images/google_adwords_logo.png';
import google_adwords_logo_no_padding from '../../images/google_adwords_logo_no_padding.png';

export class GoogleLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getImage() {
        return this.props.useOld ? google_adwords_logo : google_adwords_logo_no_padding;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    render() {
        return <img alt="Google Ads" style={this.props.styles} src={this.getImage()} height={this.getHeight()} width={this.getWidth()} hspace={this.getHSpace()} vspace={this.getVSpace()}/>
    }
}
